import commonGlobals from '@opendoor/shared-fe/commonGlobals';

import { ENV, IS_DEV, IS_PROD, IS_TEST } from './env';

const secrets = commonGlobals[ENV];
const viteEnv = import.meta.env;

export const WEB_API_URL = viteEnv?.ODFE_WEB_API_URL ?? secrets.webApiUrl;

export const GOOGLE_MAPS_KEY = secrets.googleMaps;
export const RECEPTION_FE_URL = viteEnv?.ODFE_RECEPTION_FE_URL ?? secrets.consumerFeUrl;

const uploadBucketSuffix = IS_DEV ? 'staging' : ENV;
export const ADMIN_CLIENT_UPLOAD_BUCKET = `opendoor-admin-client-upload-${uploadBucketSuffix}`;

export const CXA_EMAIL = 'hello@opendoor.com';
export const PRE_UNDERWRITING_CXA_EMAIL = 'support@opendoor.com';

export const CONTACT_PHONE = '888-352-7075';

// these are all offer polling timeouts for different envs set up for fallthrough
const testTimeoutMs = IS_TEST ? 10_000 : null;
const prodTimeoutMs = IS_PROD ? 90_000 : null;
const defaultTimeoutMs = 120_000;

export const offerPollingTimeoutThreshold = testTimeoutMs ?? prodTimeoutMs ?? defaultTimeoutMs;
export const backendRefreshBlockDurationMS = 120_000;

export const DOMAIN = {
  production: 'https://consumer.opendoor.com',
  staging: 'https://consumer.simplersell.com',
  qa: 'https://consumer.simplersell.com',
  development: 'http://localhost:3016',
  localdev: viteEnv?.ODFE_CAKE_URL ?? 'http://localhost:3016',
  test: 'https://demo.simplersell.com',
}[ENV];
export const COSMOS_DOMAIN = {
  production: 'https://www.opendoor.com',
  staging: 'https://demo.simplersell.com',
  qa: 'https://demo.simplersell.com',
  development: 'http://localhost:3011',
  localdev: viteEnv?.ODFE_WEB_API_URL ?? 'http://localhost:3011',
  test: 'https://demo.simplersell.com',
}[ENV];
export const HOMEPAGE_URL = {
  production: 'https://www.opendoor.com',
  staging: 'https://demo.simplersell.com',
  qa: 'https://demo.simplersell.com',
  development: 'http://localhost:3011/homepage-2019',
  localdev: viteEnv?.ODFE_WEB_API_URL ?? 'http://localhost:3011/homepage-2019',
  test: 'https://demo.simplersell.com',
}[ENV];

// SSVA confirmation
export const PRODUCTION_SELLER_GOOGLE_ASSESSMENT_FORM_URL_PREFIX =
  'https://docs.google.com/forms/d/e/1FAIpQLSe4glJ1pVRnUZdnpHbMDywnF1t5FAnhyQrQ7Q338WGmuelQRg/viewform?usp=pp_url';
export const STAGING_SELLER_GOOGLE_ASSESSMENT_FORM_URL_PREFIX =
  'https://docs.google.com/forms/d/e/1FAIpQLSe64KWEV4fKnLlwTAAi8PtoV09SOXtCfHAYviEJK4PrjY8KEA/viewform?usp=pp_url';
export const PRODUCTION_ALA_EXPERIENCE_FORM_URL_PREFIX =
  'https://docs.google.com/forms/d/e/1FAIpQLSeQHDLKdpDmmwpcr5r5JARETAIFxICUth4UFsWFRFV-5uY8Dw/viewform?usp=pp_url';
export const STAGING_ALA_EXPERIENCE_FORM_URL_PREFIX =
  'https://docs.google.com/forms/d/e/1FAIpQLSff6cvFZr4iSmazrSORUD7d04RADQG-lVzbhqP3ZttCP_k_TA/viewform?usp=pp_url';
export const FLIP_TOKEN_FORM_ENTRY = 'entry.1387189579';
export const EMAIL_FORM_ENTRY = 'entry.1100801854';
export const NAME_FORM_ENTRY = 'entry.678167604';

// Public token; meant to be exposed client-side.
// URL restrictions are configured in the Mapbox admin panel.
export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1Ijoib3BlbmRvb3IiLCJhIjoiY21tbndldHRzMDdsaTJwcHcwOWx0YnByZSJ9.TIy40uVqEjM_ZQxuGnFd7g';
export const MAPBOX_MAP_STYLE = 'mapbox://styles/opendoor/cktkqasmc1gbe17pfo2cm7ybb';

export const HELLOSIGN_CLIENT_ID = secrets.hellosignClientID;
